export function registerLeadPostServiceWorker(): void {
    const shouldRegister = Boolean((window as any).__LP_ENABLE_SERVICE_WORKER);

    if (!window.isSecureContext || !('serviceWorker' in navigator)) {
        return;
    }

    const unregister = () => {
        void navigator.serviceWorker.getRegistrations()
            .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
            .then(() => {
                if (!('caches' in window)) {
                    return;
                }

                return window.caches.keys().then((cacheNames) => Promise.all(
                    cacheNames
                        .filter((cacheName) => cacheName.startsWith('leadpost-static-'))
                        .map((cacheName) => window.caches.delete(cacheName)),
                ));
            })
            .catch(() => {});
    };

    if (!shouldRegister) {
        if (document.readyState === 'complete') {
            unregister();
        } else {
            window.addEventListener('load', unregister, { once: true });
        }

        return;
    }

    const register = () => {
        navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {});
    };

    if (document.readyState === 'complete') {
        register();
        return;
    }

    window.addEventListener('load', register, { once: true });
}
